import { combineReducers } from "redux";
import { addHealthcampPatientReducer } from "../addHealthcampPatient/Reducer";
import { addPointDataReducer } from "../addPointData/Reducer";
import { getHealthcampListReducer } from "../healthcampList/Reducer";
import { getPatientDataPointListReducer } from "../patientDataPointList/patientDataPointListByPatientID/Reducer";
import { doctorsOnboardingImcompleteReducer } from "../doctorsOnboardingImcomplete/Reducer";
import { importFromPhoneReducer } from "../importFromPhone/Reducer";
import { executiveListReducer } from "../executiveListDropDown/Reducer";
import { assignExecutiveReducer } from "../assignExecutive/Reducer";
import { previewListReducer } from "../Preview/previewApi/Reducer";
import { templateListReducer } from "../Preview/templateListApi/Reducer";
import { historyandIllnessReducer } from "../HistoryAndIllness/AddHealthAndIllness/Reducer";
import { addhistoryandIllnessReducer } from "../HistoryAndIllness/GetHealthAndIllness/Reducer";
import { getIdentifyReducer } from "../IdentifydataAndSource/GetIdentify/Reducer";
import { addIdentifyReducer } from "../IdentifydataAndSource/AddIdentify/Reducer";
import { deleteIdentifyReducer } from "../IdentifydataAndSource/DeleteIdentify/Reducer";
import { getInsuranceReducer } from "../Insurance/GetInsurance/Reducer";
import { addInsuranceReducer } from "../Insurance/AddInsurance/Reducer";
import { acceptorRejectBookingReducer } from "../AppointmentBooking/Reducer";
import { getPatientCaseDetailsReducer } from "../ConsultationOption/Reducer";
import { getCorporatePackageListReducer } from "../CorporatePackage/Package/Reducer";
import { getCorporatePackageToggleReducer } from "../CorporatePackage/TogglePackageStatus/Reducer";
import { getPatientListReducer } from "../CorporatePackage/PatientTeam/PatientList/Reducer";
import { getCorporatePackagePaymentListReducer } from "../CorporatePackage/Payment/Reducer";
import {
  addSummary,
  contactDetail,
  doctorAppointment,
} from "../Doctor/Reducer";
import {
  addDoctorReducer,
  drApproveOrReject,
} from "../DoctorOnboarding/Reducer";
import {
  getExecutiveListReducer,
  deleteExecutiveReducer,
  addExecutiveReducer,
  editExecutiveReducer,
} from "../Executive/Reducer";
import {
  getDoctorReducer,
  getOnboardingDoctorRequestReducer,
  getOnboardingDoctorRejectReducer,
  getOnboardingDoctorIncompleteReducer,
  getDoctorListReducer,
  getPatientReducer,
  getTaskListReducer,
  getQuestionListReducer,
  getCaseReducer,
  getQuestionReducer,
  getCCReducer,
  addCCReducer,
  deleteDocumentReducer,
  getAllCaseReducer,
  getAllInactiveTaskListReducer,
  getActiveCorporateListReducer,
  getInactiveCorporateListReducer,
  getActiveCorporatePatientListReducer,
  getInactiveCorporatePatientListReducer,
  acceptOrRejectBookingAppointment,
  taskCloseByAdmiin,
} from "./Reducer";
import { stepandSectionListReducer } from "../StepsAndSection/Reducer";
import { addPastMedicalReducer } from "../PastMedicallHistory/AddPastMedicalHistory/Reducer";
import { getPastMedicalReducer } from "../PastMedicallHistory/GetPastMedicalHistory/Reducer";
import { deletePastMedicalReducer } from "../PastMedicallHistory/DeletePastMedicalHistory/Reducer";
import { symptomAddReducer } from "../Symptom/addSymptom/Reducer";
import { symptomListReducer } from "../Symptom/getSymptom/Reducer";
import { getTelehealthMeetingReducer } from "../Telehealth/Reducer";
import { getExecutiveTaskListReducer, taskCloseReducer } from "../Task/Reducer";
import {
  addPatientTeamReducer,
  appointmentPatientTeamListReducer,
} from "../Patient/AppointmentPatientTeam/Reducer";
import {
  appointmentConfirmReducer,
  appointmentListReducer,
  appointmentPaymentListReducer,
  appointmentPaymentStatusReducer,
} from "../Patient/AppointmentPayment/Reducer";
import {
  addDoctorTeamTypeReducer,
  addDoctorToCase,
  deleteDoctorFromCase,
  getaddedDoctorList,
  getSpecialist,
  getSpecialistDoctor,
  selectedDoctorTeamType,
} from "../Patient/AppointmentSelectDoctor/Reducer";
import {
  addDrNotes,
  addNotesForDrReducer,
  changeDrNoteStatus,
  changeNoteStatusForDrReducer,
  NotesForDrReducer,
} from "../Notes/Reducer";
import {
  askQuestionReducer,
  createOrScheduleReducer,
  deleteMeetingReducer,
  doctorListForCaseReducer,
  meetingListReducer,
  questionListReducer,
} from "../Patient/DoctorPatientInteraction/Reducer";
import { addAnswer, questionverifyReducer } from "../QuestionAnswer/Reducer";
import {
  addPatientInPackageReducer,
  getPatientTeamListReducer,
} from "../CorporatePackage/PatientTeam/Reducer";
import {
  addOrupdateHealthRecordReducer,
  getBloodGroupDropdownListReducer,
  getHealthRecordReducer,
  getLanguageDropdownListReducer,
  getMaritalStatusDropdownListReducer,
  getSexualorientationDropdownListReducer,
  gettGenderDropdownListReducer,
  gettRelationshipDropdownListReducer,
} from "../Patient/DemographicsDetails/Reducer";
import {
  addOrEditPatientDataImportConfigReducer,
  getPatientDataImportConfigListReducer,
  getPatientImportListReducer,
} from "../Patient/ImportData/Reducer";
import { deleteOpinion, getOpinion } from "../Patient/FinalOpinion/Reducer";
import {
  addPatientteamByAdminReducer,
  getpatientTeamListReducer,
} from "../PatientTeam/Reducer";
import { getHealthcampPatientReducer } from "../patientListOfHealthcamp/Reducer";
import { addDemographicsReducer } from "../DemographicsDetails/AddDemographicsDetails/Reducer";
import { getBloodGroupListReducer } from "../DemographicsDetails/BloodGroupList/Reducer";
import { getGenderListReducer } from "../DemographicsDetails/GenderList/Reducer";
import { getDemographicsDetailsByPtIdReducer } from "../DemographicsDetails/GetAppointmentList/Reducer";
import { getLanguageListReducer } from "../DemographicsDetails/LanguageList/Reducer";
import { getMaritalListListReducer } from "../DemographicsDetails/MaritalStatusList/Reducer";
import { getRelationshipListReducer } from "../DemographicsDetails/RelationShipList/Reducer";
import { getSexualOrientationListReducer } from "../DemographicsDetails/SexualOrientationList/Reducer";
import { updateDemographicsDetailsByPatientIdReducer } from "../DemographicsDetails/UpdateDemographicsDetails/Reducer";
import { imageUploadReducer } from "../ImageUpload/Reducer";
import { logOutReducer } from "../logOut/Reducer";
import { addHealthcampExistingPatientReducer } from "../addExistingHealthcampPatient/Reducer";
import { govtIDProofReducer } from "../DemographicsDetails/govtIdProofList/Reducer";
import { patientSearchReducer } from "../PatientSearchApi/Reducer";
import { addMasterConfigReducer } from "../addMasterImportConfig/Reducer";
import { getPatientImportConfigListReducer } from "../getPatientImportConfigList/Reducer";
import { addPatientImportConfigReducer } from "../addPatientImportConfig/Reducer";
import { editPatientImportConfigReducer } from "../editPatientImportConfig/Reducer";
import { UpdatePatientDataPointReducer } from "../UpdatePatientDataPoint/Reducer";
import { simpleHistoryReducer } from "../SimpleHistory/Reducer";
import { getPatientDataDetailsListReducer } from "../patientDataDetails/patientDataPointListByPatientID/Reducer";
import { addPointDataDetailsReducer } from "../patientDataDetails/addPatientDetails/Reducer";
import { updatePatientDataDetailsReducer } from "../patientDataDetails/UpdatePatientDataPoint/Reducer";
import { getAllTaskListReducer } from "../TaskAdmin/List/Reducer";
import { executiveDropDownListReducer } from "../TaskAdmin/ExecutiveList/Reducer";
import { assigntaskToExecutiveReducer } from "../TaskAdmin/AssignExecutive/Reducer";
import { updatePatientCaseStatusReducer } from "../Patient/AppointmentSelectPatient/updatePatientCaseDetails/Reducer";
import { getCaseStatusListReducer } from "../Patient/AppointmentSelectPatient/caseStatusList/Reducer";
import { getPatientCaseDetailsByIdReducer } from "../Patient/AppointmentSelectPatient/getPatientCseDetailsById/Reducer";
import { deletePatientCaseReducer } from "../Patient/FilePreparation/deletePatientCase/Reducer";
import { findUserReducer } from "../ImportData/FindUserNumber/Reducer";
import { importCallReducer } from "../ImportData/ImportFromPhone/Reducer";
import { getAdminNoteListByPatientReducer } from "../Notes/GetNotesListByPateint/Reducer";
import { AddNoteReducer } from "../Notes/addNotes/Reducer";
import { updateNoteReducer } from "../Notes/updateNoteStatus/Reducer";
import { adminPaymentReducer } from "../PaymentAdmin/PaymentList/Reducer";
import { doctorQuriesListReducer } from "../DoctorQuriesList/Reducer";
import { getDoctorDetailsByIdReducer } from "../Doctor/GetDoctorDetailsById/Reducer";
import { statusPaymentReducer } from "../PaymentAdmin/PaymentStatus/Reducer";
import { patientQuriesListReducer } from "../PatientQuriesList /Reducer";
import { updateDoctorDetailsReducer } from "../Doctor/updateDoctorDetails/Reducer";
import { getDoctorContactDetailsReducer } from "../Doctor/GetDoctorContactDetails/Reducer";
import { updateDoctorContactDetailsReducer } from "../Doctor/updateDoctorContactDetails/Reducer";
import { allappointmentListReducer } from "../Appointment/AppointmentList/Reducer";
import { appointmentDeactivateReducer } from "../Appointment/AppointmentDeactive/Reducer";
import { GetExtractObservationByPatientIdReducer } from "../getExtractObservationByPatientId/Reducer";
import { getPatientDetailsByIdReducer } from "../patientDataDetails/patientDetailsById/Reducer";
import { extractObservationByDetailsIdReducer } from "../extractObservationDetailsById/Reducer";
import { extractObservationByPatientIdReducer } from "../extractObservationDetailsByPatientId/Reducer";
import { GetExtractObservationByDetailsIdReducer } from "../GetViewExtractObservation/Reducer";
import { reviewNeededReducer } from "../patientDataDetails/reviewNeeded/Reducer";
import { getDoctorWorkScheduleListReducer } from "../Doctor/Schedule/GetDoctorWorkScheduleList/Reducer";
import { getWeekDayListReducer } from "../Doctor/Schedule/WeekDayList/Reducer";
import { addScheduleReducer } from "../Doctor/Schedule/AddSchedule/Reducer";
import { deleteScheduleReducer } from "../Doctor/Schedule/deleteSchedule/Reducer";
import { getOpinionTypeListReducer } from "../ConsultationOption/OpinionType/Reducer";
import { getSecondOpinionTypeListReducer } from "../ConsultationOption/SecondOpinionType/Reducer";
import { getConsultationTypeListReducer } from "../ConsultationOption/ConsultationType/Reducer";
import { getResponseTimeTypeListReducer } from "../ConsultationOption/ResponseTimeType/Reducer";
import { getQuestionnaireListReducer } from "../FilePreparation/Questionnaire/Reducer";
import { getPatientDataListReducer } from "../FilePreparation/GetPatientDataList/Reducer";
import { deletePatientDataByIdReducer } from "../FilePreparation/DeletePatientDataById/Reducer";
import { addPatientDataReducer } from "../FilePreparation/AddPatientDataList/Reducer";
import { getDoctorTeamTypeListReducer } from "../Patient/AppointmentSelectDoctor/DoctorTeamTypeList/Reducer";
import { AddCaseReducer } from "../ConsultationOption/AddCase/Reducer";
import { EditCaseReducer } from "../ConsultationOption/EditCase/Reducer";
import { addrequestAppointmentReducer } from "../Patient/PatientRequestAppointment/Reducer";
import { requestAppointmentDetailsReducer } from "../Patient/GetAppointmentList/Reducer";
import { patientSearchByHealthCampIdReducer } from "../PatientSearchByHealcampId/Reducer";
import { getFilteredHealthCampPatientListReducer } from "../FilterHealthCampDetails/Reducer";
import { getOrganizationListReducer } from "../OrganizationList/Reducer";
import { addOrganizationPatientReducer } from "../AddOrganizationPatient/Reducer";
import { patientSearchByOrganizationIdReducer } from "../PatientSearchByOrganizationId/Reducer";
import { getOrganizationPatientReducer } from "../PatientListByOrganization/Reducer";
import { emailOtpgenerationReducer } from "../emailOtpGeneration/Reducer";
import { emailOtpAuthReducer } from "../emailOtpAuth/Reducer";
import { forgotPasswordReducer } from "../forgotPassword/Reducer";
import { addProviderOrgAdministratorReducer } from "../AddAdministratorApi/Reducer";
import { jwtAuthTokenReducer } from "../jwtProviderLogIn/Reducer";
import { getProviderLoginDetailsReducer } from "../jwtProviderLogIn/providerLoginDetails/Reducer";
import { providerOrgPatientDetailsReducer } from "../ProviderOrganizationPatientDetailsList/Reducer";
import { getProviderOrganizationListReducer } from "../ProviderOrganizationList/Reducer";
import { providerPatientListReducer } from "../patientList/Reducer";
import { providerDoctorListReducer } from "../doctorList/Reducer";
import { providerReportListReducer } from "../reportList/Reducer";

const Reducer = combineReducers({
  apiAuthToken: jwtAuthTokenReducer,
  providerLoginDetailsRes: getProviderLoginDetailsReducer,
  doctorValue: getDoctorReducer,
  doctorRequestValue: getOnboardingDoctorRequestReducer,
  doctorRejectValue: getOnboardingDoctorRejectReducer,
  doctorIncompleteValue: getOnboardingDoctorIncompleteReducer,
  doctorListValue: getDoctorListReducer,
  patientValue: getPatientReducer,
  taskListValue: getTaskListReducer,
  healthcampListValue: getHealthcampListReducer,
  organizationListValue: getOrganizationListReducer,
  healthcampPatientListValue: getHealthcampPatientReducer,
  organizationPatientListValue: getOrganizationPatientReducer,
  alltaskListValue: getAllTaskListReducer,
  allinactivetasklist: getAllInactiveTaskListReducer,
  questionListValue: getQuestionListReducer,
  caseValue: getCaseReducer,
  allcaseValue: getAllCaseReducer,
  questionValue: getQuestionReducer,
  ccValue: getCCReducer,
  ccAddVlaue: addCCReducer,
  deleteDocumentValue: deleteDocumentReducer,
  // allAppointmentListValue: getAllAppointmentListReducer,
  deleteAppointment: appointmentDeactivateReducer, //deactivateAppointment,
  allPatientTeamListValue: getpatientTeamListReducer,
  allPaymentListValue: adminPaymentReducer,
  adminPatientQueryListValue: patientQuriesListReducer,
  adminDoctorQueryListValue: doctorQuriesListReducer,
  activeCorporateListValue: getActiveCorporateListReducer,
  inactiveCorporateListValue: getInactiveCorporateListReducer,
  activeCorporatePatientValue: getActiveCorporatePatientListReducer,
  inactiveCorporatePatientValue: getInactiveCorporatePatientListReducer,
  patientDataPointList: getPatientDataPointListReducer,
  addPointData: addPointDataReducer,
  addHealthcampPatientData: addHealthcampPatientReducer,
  doctorOnboardingStatus: doctorsOnboardingImcompleteReducer,
  stepAndSection: stepandSectionListReducer,
  addpastMedical: addPastMedicalReducer,
  getPastMedical: getPastMedicalReducer,
  deletePastMedical: deletePastMedicalReducer,
  addSymptom: symptomAddReducer,
  symptomList: symptomListReducer,
  importfromphone: importFromPhoneReducer,
  importPhoneDataValue: importCallReducer,
  findUserValue: findUserReducer,
  executiveList: executiveListReducer,
  assignExecutive: assignExecutiveReducer,
  previewList: previewListReducer,
  templateList: templateListReducer,
  acceptOrRejectBookingAppointmentValue: acceptorRejectBookingReducer,
  healthandIllness: historyandIllnessReducer,
  addHealthAndIllness: addhistoryandIllnessReducer,
  getIdentify: getIdentifyReducer,
  addIdentify: addIdentifyReducer,
  deleteIdentify: deleteIdentifyReducer,
  getInsurance: getInsuranceReducer,
  addInsurance: addInsuranceReducer,
  opinionTypeValue: getOpinionTypeListReducer,
  secondOpinionValue: getSecondOpinionTypeListReducer,
  consultationTypeValue: getConsultationTypeListReducer,
  responseTimeValue: getResponseTimeTypeListReducer,
  addPatientCase: AddCaseReducer, //addPatientCaseReducer,
  editPatientCase: EditCaseReducer, //editPatientCaseReducer,
  getPatientCaseDetails: getPatientCaseDetailsReducer,
  corporatePackageTogglevalue: getCorporatePackageToggleReducer,
  corporatePackageValue: getCorporatePackageListReducer,
  patientTeamPatientListvalue: getPatientListReducer,
  patientteamPatientPaymentValue: getCorporatePackagePaymentListReducer,
  addDoctorSummary: addSummary,
  doctorContactDetails: contactDetail,
  workSchedule: getDoctorWorkScheduleListReducer,
  deleteSchedule: deleteScheduleReducer,
  addWorkSchedule: addScheduleReducer,
  appointment: doctorAppointment,
  doctorDetails: getDoctorDetailsByIdReducer,
  weekdayList: getWeekDayListReducer,
  addDoctorvalue: addDoctorReducer,
  drApproveRejectValue: drApproveOrReject,
  telehealthMeetingValue: getTelehealthMeetingReducer,
  executiveDropdownListvalue: executiveDropDownListReducer,
  assignExecutiveValues: assigntaskToExecutiveReducer,
  taskCloseValues: taskCloseReducer,
  executiveTaskList: getExecutiveTaskListReducer,
  executiveListValue: getExecutiveListReducer,
  addRequestAppointment: addrequestAppointmentReducer,
  getrequestAppointmentDetails: requestAppointmentDetailsReducer,
  deleteExecutive: deleteExecutiveReducer,
  addExecutive: addExecutiveReducer,
  editExecutive: editExecutiveReducer,
  appointmentPatientTeamValue: appointmentPatientTeamListReducer,
  addPatientTeamValue: addPatientTeamReducer,
  appointmentPaymentListValue: appointmentPaymentListReducer,
  appointmentListValue: appointmentListReducer,
  appointmentPaymentStatusValue: appointmentPaymentStatusReducer,
  appointmentConfirmValue: appointmentConfirmReducer,
  doctorTeamTypeListValue: getDoctorTeamTypeListReducer,
  selectedDoctorTeamType: selectedDoctorTeamType,
  addDoctorTeamType: addDoctorTeamTypeReducer,
  specialist: getSpecialist,
  specialistDoctor: getSpecialistDoctor,
  addSpecialist: addDoctorToCase,
  deletedoctor: deleteDoctorFromCase,
  getaddedDoctor: getaddedDoctorList,
  caseStatusList: getCaseStatusListReducer,
  addStatus: updatePatientCaseStatusReducer,
  getPatientCaseStatus: getPatientCaseDetailsByIdReducer,
  changeDrNotesStatusValue: changeNoteStatusForDrReducer,
  addNotesForDrValue: addNotesForDrReducer,
  notesForDrvalues: NotesForDrReducer,
  changeDrNoteStatusValue: changeDrNoteStatus,
  addDrNote: addDrNotes,
  drNoteListValue: getAdminNoteListByPatientReducer,
  bookingValue: acceptOrRejectBookingAppointment,
  taskCloseValue: taskCloseByAdmiin,
  updateDoctorDetails: updateDoctorContactDetailsReducer,
  createOrScheduleMeetingValue: createOrScheduleReducer,
  deletetelehealthMeetingValue: deleteMeetingReducer,
  askQuestionToPatientValue: askQuestionReducer,
  doctorListForcasevalue: doctorListForCaseReducer,
  meetingListValue: meetingListReducer,
  questionListValueUnderCase: questionListReducer,
  adminQuestionAnswerValue: addAnswer,
  verifyQuestionValue: questionverifyReducer,
  patientTeamValue: getPatientTeamListReducer,
  addPatientInCorporatePackagevalue: addPatientInPackageReducer,
  genderListvalue: gettGenderDropdownListReducer,
  relationshipListValue: gettRelationshipDropdownListReducer,
  bloodGroupListvalue: getBloodGroupDropdownListReducer,
  maritalStatusValue: getMaritalStatusDropdownListReducer,
  sexualOrientationValue: getSexualorientationDropdownListReducer,
  languagelistValue: getLanguageDropdownListReducer,
  addOrUpdateHealthRecordValue: addOrupdateHealthRecordReducer,
  gethealthRecordvalue: getHealthRecordReducer,
  getPatientImportConfigListConfigValue: getPatientDataImportConfigListReducer,
  addEditImportConfigValue: addOrEditPatientDataImportConfigReducer,
  getpatientDataListValue: getPatientImportListReducer,
  deleteCaseValue: deletePatientCaseReducer,
  opinion: getOpinion,
  deleteOpinion: deleteOpinion,
  addPatientteamByAdminvalue: addPatientteamByAdminReducer,
  verifyPaymentvalue: statusPaymentReducer,
  addDemographics: addDemographicsReducer,
  getDemographicsDetailsByPtId: getDemographicsDetailsByPtIdReducer,
  getPatientRelationshipList: getRelationshipListReducer,
  getPatientBloodGroupList: getBloodGroupListReducer,
  getPatientGenderList: getGenderListReducer,
  getPatientLanguageList: getLanguageListReducer,
  getPatientMaritalList: getMaritalListListReducer,
  getPatientSexualOrientation: getSexualOrientationListReducer,
  updateDemographicsDetails: updateDemographicsDetailsByPatientIdReducer,
  imageUploading: imageUploadReducer,
  logOutRes: logOutReducer,
  addExistingPatientValue: addHealthcampExistingPatientReducer,
  govtIdProofList: govtIDProofReducer,
  patientSearchListValue: patientSearchReducer,
  addMasterImport: addMasterConfigReducer,
  getPatientImportConfigList: getPatientImportConfigListReducer,
  addPatientImportConfig: addPatientImportConfigReducer,
  editImportConfig: editPatientImportConfigReducer,
  editPatientDataPoint: UpdatePatientDataPointReducer,
  showHistory: simpleHistoryReducer,
  getPatientDataDetailsRes: getPatientDataDetailsListReducer,
  addPointDataDetailsRes: addPointDataDetailsReducer,
  updatePatientDataDetailsRes: updatePatientDataDetailsReducer,
  addNoteRes: AddNoteReducer,
  updateNoteRes: updateNoteReducer,
  updateDoctorDetailsRes: updateDoctorDetailsReducer,
  getDoctorContactDetailsRes: getDoctorContactDetailsReducer,
  allApptList: allappointmentListReducer,
  extractObservationByDetailsIdValue: extractObservationByDetailsIdReducer,
  extractObservationByPatientIdValue: extractObservationByPatientIdReducer,
  getExtractObservationValue: GetExtractObservationByPatientIdReducer,
  getPatientDetailsById: getPatientDetailsByIdReducer,
  getExtractObservationByDetailsValue: GetExtractObservationByDetailsIdReducer,
  reviewNeeded: reviewNeededReducer,
  patientQuestionnaireListRes: getQuestionnaireListReducer,
  patientDataListRes: getPatientDataListReducer,
  deletePatientDataByIdRes: deletePatientDataByIdReducer,
  addPatientDataListRes: addPatientDataReducer,
  searchPatientByHealthCampIdValue: patientSearchByHealthCampIdReducer,
  filteredHealthCampPatientListRes: getFilteredHealthCampPatientListReducer,
  addOrganizationPatientValue: addOrganizationPatientReducer,
  patientSearchByOrganizationIdValue: patientSearchByOrganizationIdReducer,
  emailOtpGeneration: emailOtpgenerationReducer,
  emailOtpAuth: emailOtpAuthReducer,
  forgotPassword: forgotPasswordReducer,
  addProviderOrgAdministratorValue: addProviderOrgAdministratorReducer,
  providerOrgPtDetails: providerOrgPatientDetailsReducer,
  getProviderOrganizationListValue: getProviderOrganizationListReducer,
  providerPatientListValue: providerPatientListReducer,
  providerDoctorListValue: providerDoctorListReducer,
  providerReportListValue: providerReportListReducer
});

export default Reducer;
